import { useTranslation } from 'react-i18next'

export default function PaymentSection({ form, setField }) {
	const { t } = useTranslation()

	return (
		<div className="rounded-lg border border-gray-200 px-2 py-2 mx-2 md:mx-0 md:px-4 md:py-4">
			<div className="text-sm text-gray-600 mb-2">{t('invoices.form.payment.title')}</div>
			<div className="grid grid-cols-1 md:grid-cols-3 gap-4">
				<div>
					<label className="block text-sm font-medium text-gray-700 mb-1">{t('invoices.form.payment.status')}</label>
					<select
						value={form.status}
						onChange={e => setField('status', e.target.value)}
						className="block w-full rounded-lg border-0 py-2.5 px-3.5 ring-1 ring-inset ring-gray-300 focus:ring-2 focus:ring-indigo-600">
						<option value="issued">{t('invoices.form.payment.statusOptions.issued')}</option>
						<option value="overdue">{t('invoices.form.payment.statusOptions.overdue')}</option>
						<option value="paid">{t('invoices.form.payment.statusOptions.paid')}</option>
					</select>
				</div>

				<div className={`block`}>
					<label className="block text-sm font-medium text-gray-700 mb-1">{t('invoices.form.payment.paymentType')}</label>
					<select
						value={form.paymentType}
						onChange={e => setField('paymentType', e.target.value)}
						disabled={form.status !== 'paid'}
						className="block w-full rounded-lg border-0 py-2.5 px-3.5 ring-1 ring-inset ring-gray-300 focus:ring-2 focus:ring-indigo-600 disabled:bg-gray-100 disabled:text-gray-500">
						<option value="card">{t('invoices.form.payment.paymentTypes.card')}</option>
						<option value="bank_transfer">{t('invoices.form.payment.paymentTypes.bankTransfer')}</option>
						<option value="cash">{t('invoices.form.payment.paymentTypes.cash')}</option>
						<option value="other">{t('invoices.form.payment.paymentTypes.other')}</option>
					</select>
				</div>

				<div className={`block`}>
					<label className="block text-sm font-medium text-gray-700 mb-1">{t('invoices.form.payment.paymentDate')}</label>
					<input
						type="date"
						value={form.paymentDate}
						onChange={e => setField('paymentDate', e.target.value)}
						disabled={form.status !== 'paid'}
						className="block w-full rounded-lg border-0 py-2.5 px-3.5 ring-1 ring-inset ring-gray-300 focus:ring-2 focus:ring-indigo-600 disabled:bg-gray-100 disabled:text-gray-500"
					/>
				</div>
			</div>
		</div>
	)
}
